import { CanvasProvider } from './contexts/CanvasContext';
import { DesignerLayout } from './components/layout/DesignerLayout';

function App() {
  return (
    <CanvasProvider>
      <DesignerLayout />
    </CanvasProvider>
  );
}

export default App;
